// require('./bootstrap')

window.Vue = require('vue')

// require('./components')

const app = new Vue({
    el: '#app'
})



// WEBPACK FOOTER //
// ./src/js/app.js